import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Cache di sessione: il flag cambia raramente e non serve invalidazione real-time.
let _offerFlagCache = null;

/**
 * Legge il flag `subcontract_offer_enabled` da /api/settings/company.
 * Comportamento:
 *  - undefined: caricamento in corso;
 *  - true/false: valore corrente.
 * Cache di sessione (basta per un flag di rollout). Un toggle del flag richiede
 * reload pagina, come da specifica F.3 §8.
 */
export const useSubcontractOfferEnabled = () => {
  const [enabled, setEnabled] = useState(_offerFlagCache);
  useEffect(() => {
    if (_offerFlagCache !== null) {
      setEnabled(_offerFlagCache);
      return;
    }
    axios.get(`${API}/api/settings/company`, { withCredentials: true })
      .then(r => {
        _offerFlagCache = !!r.data?.subcontract_offer_enabled;
        setEnabled(_offerFlagCache);
      })
      .catch(() => setEnabled(false));
  }, []);
  return enabled;
};

/** Invalidazione manuale (per tool interni / test). */
export const _resetSubcontractOfferFlagCache = () => {
  _offerFlagCache = null;
};
